<div class="main">
    <!-- メインコンテンツ -->
    <a id="jump-top"></a>
    <div class="main-content">
      <div class="contact p-col-12 card pb-3">
        <div class="p-col-12 head">お問い合わせ</div>
        <p-divider type="solid"></p-divider>
        <div class="p-col-12 p-pt-3 p-pb-3">本サイトの運営、事業主旨に関することは、下記に問い合わせください。</div>
        <div class="p-col-12 p-pt-3 p-pb-3 text-bold">福岡県福祉こども政策部こども未来課こども企画係<br />中高生と乳幼児のふれあい体験支援事業担当<br />　E-mail：fureai@pref.fukuoka.lg.jp<br />　TEL：092-643-3013（こども未来課代表電話）</div>
        <div class="p-col-12 p-pt-3 p-pb-3">※マッチングに関するご相談は、ログイン後、メッセージ画面より、コーディネーター宛にメッセージをお送りください。</div>
      </div>
    </div>
    <app-landing-footer></app-landing-footer>
</div>
